import { render, staticRenderFns } from "./FadeTranslate.vue?vue&type=template&id=2f274c04&"
import script from "./FadeTranslate.vue?vue&type=script&lang=js&"
export * from "./FadeTranslate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports